// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = ({
  mainContainer: {
    width: 200,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 10,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    margin: 10,
  },
  square: {
    width: '100%',
    height: 130,
    backgroundColor: 'grey',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  text: {
    padding: '20px 20px',
    textAlign: 'center',
    color: GlobalStyles.color.COLOR_SECONDARY,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
});

export default styles;
